import { defineStore } from 'pinia'

interface DeviceIdState {
  deviceId: string
}

interface DeviceIdActions {
  setDeviceId: (deviceId: string) => void
  getDeviceId: () => string
}

function getOrCreateDeviceId(): string {
  let id = localStorage.getItem('deviceId')
  if (!id) {
    id = crypto.randomUUID?.() || Math.random().toString(36).substring(2) + Date.now()
    localStorage.setItem('deviceId', id)
  }
  return id
}

export const useDeviceIdStore = defineStore<
  'deviceId',
  DeviceIdState,
  Record<string, any>,
  DeviceIdActions
>({
  id: 'deviceId',
  state: (): DeviceIdState => ({
    deviceId: getOrCreateDeviceId(),
  }),
  actions: {
    setDeviceId(deviceId: string) {
      this.deviceId = deviceId
    },
    getDeviceId(): string {
      return this.deviceId
    },
  },
})
